module.exports = __webpack_public_path__ + "5e311b76e34ac8f32c626c7ddd37da01.svg";